import React, { useRef, useState, useEffect, useCallback } from 'react';
import { animatedScrollTo } from 'app/home/general-components/AnimatedScroll';
// import log from '../Logging';

import "./TouchPicker.scss"

function scale(min, max, progress) {
    if (progress <= 0) {
        return min;
    } else if (progress >= 1) {
        return max;
    } else {
        return progress * (max - min) + min;
    }
}

export default function Picker(
    {
        height, width,
        items, pickerName,
        baseFontSize, minScale, minOpacity, color,
        indexSelectedCallback, defaultSelectedIndex,
        style,
    }
) {
    const pickerRef = useRef();
    const [initialized, setInitialized] = useState(false);
    const selectedIndex = useRef(defaultSelectedIndex);

    const touching = useRef(false);

    const animatedScrollEnableRef = useRef(true);
    const scrolling = useRef(false);
    const scrollingTimeout = useRef(null);

    const _color = color ? color : "#454545";
    const _style = style ? style : {};

    const moveToIndex = useCallback((index, duration) => {
        if (!pickerRef.current)
            return;

        if (duration === undefined)
            duration = 200;

        const scrollUnit = pickerRef.current.scrollHeight / (items.length + 2);
        animatedScrollTo(pickerRef.current, scrollUnit * (index), duration, animatedScrollEnableRef);
    }, [items]);

    const effectView = useCallback(() => {
        if (!pickerRef.current)
            return;

        const scrollHeight = pickerRef.current.scrollHeight;
        const scrollUnit = scrollHeight / (items.length + 2);
        const scrollTop = Math.min(Math.max(pickerRef.current.scrollTop, 0), scrollHeight - scrollUnit*3);
        const pointerOfSelection = scrollTop / scrollUnit + 1;

        let selectedCandidate = null;
        let minDistanceOfSelectedCandidate = 100000;

        for (let i = 0; i < items.length; i++) {
            let distance = Math.abs(pointerOfSelection - (i + 1));
            let progress = 1 - Math.min(distance, 1);
            if (minDistanceOfSelectedCandidate > distance) {
                minDistanceOfSelectedCandidate = distance;
                selectedCandidate = i;
            }

            // print progress
            // log("progress", progress, scale(minOpacity, 1, progress), String(scale(minScale, 1, progress)));

            let op = scale(minOpacity, 1, progress);
            let sc = "scale(" + String(scale(minScale, 1, progress)) + ")";

            pickerRef.current.children[i + 1].children[0].style.opacity = op;
            pickerRef.current.children[i + 1].children[0].style.transform = sc;
        }

        return selectedCandidate;
    }, [items, minOpacity, minScale])

    const onScroll = useCallback(() => {
        // console.log("onScroll");
        animatedScrollEnableRef.current = true;

        const selectedCandidate = effectView();

        if (initialized) {
            selectedIndex.current = selectedCandidate;
            if (indexSelectedCallback && typeof (indexSelectedCallback) === 'function')
                indexSelectedCallback(selectedCandidate);
        }

        if (scrollingTimeout.current) {
            clearTimeout(scrollingTimeout.current);
        }
        scrolling.current = true;
        scrollingTimeout.current = setTimeout(() => {
            // log("onScroll Stoped");
            scrolling.current = false;
            if (!touching.current)
                moveToIndex(selectedIndex.current);
        }, 300);

    }, [effectView, moveToIndex, initialized, indexSelectedCallback]);

    const onTouchStart = useCallback(() => {
        // console.log("onTouchStart");
        animatedScrollEnableRef.current = false;

        touching.current = true;
    }, [])

    const onTouchEnd = useCallback(() => {
        // console.log("onTouchEnd");
        animatedScrollEnableRef.current = true;

        touching.current = false;
        if (!scrolling.current)
            moveToIndex(selectedIndex.current);
    }, [moveToIndex]);

    useEffect(() => {
        if (defaultSelectedIndex) {
            setInitialized(false);
            moveToIndex(defaultSelectedIndex, 500);
            setTimeout(() => {
                setInitialized(true);
            }, 500 + 100);
        } else {
            setInitialized(false);
            effectView();
            setTimeout(() => {
                setInitialized(true);
            }, 500 + 100);
        }
    }, [moveToIndex, defaultSelectedIndex, effectView]);

    return (
        <div className="picker-column"
            ref={pickerRef}
            style={{ height, ..._style }}
            onTouchEnd={onTouchEnd}
            onTouchStart={onTouchStart}

            // onDragEnd={onTouchEnd}
            // onDragStart={onTouchStart}

            onScroll={onScroll}>

            <div className="picker-item" style={{ height: height / 3, width }} />
            {
                items.map(
                    (item, index) => {
                        return (<div
                            style={{ height: height / 3 }}
                            className="picker-item"
                            key={pickerName + "_" + String(index)}>

                            <div className="picker-item-content"
                                style={{ color: _color, fontSize: baseFontSize }}>
                                {item}
                            </div>

                        </div>)
                    }
                )
            }
            <div className="picker-item" style={{ height: height / 3, width }} />
        </div>
    );
}